export default "__VITE_ASSET__CJ$dRSAF__"